import {
  ChangeDetectionStrategy,
  Component, computed,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  HostListener,
  inject,
  Signal,
  viewChild
} from '@angular/core';
import {HeaderProfileUserInfoComponent, UserStore} from "@vision-inspection/user";
import {InfoMenuComponent} from "../info-menu/info-menu.component";
import {AppMenuComponent} from "../app-menu/app-menu.component";
import {AdministrationMenuComponent} from "../administration-menu/administration-menu.component";
import {RedirectWithPostService} from "@vision-inspection/shared";

enum MenuType {
  AppMenu = 'app-menu',
  AdministrationMenu = 'administration-menu',
  InfoMenu = 'info-menu',
  UserMenu = 'user-menu'
}

interface LogoutRazorPostData {
  returnUrl?: string;
}

@Component({
  selector: 'app-horizontal-menu',
  imports: [
    HeaderProfileUserInfoComponent,
    InfoMenuComponent,
    AppMenuComponent,
    AdministrationMenuComponent
  ],
  templateUrl: './horizontal-menu.component.html',
  styleUrl: './horizontal-menu.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HorizontalMenuComponent {
  protected selectedMenu: MenuType | null = null;
  protected readonly MenuType: typeof MenuType = MenuType;

  private readonly eRef: ElementRef = inject(ElementRef);
  private menuHeader: Signal<ElementRef<HTMLElement> | undefined> = viewChild<ElementRef<HTMLElement>>('headermenu');
  private readonly userStore: UserStore = inject(UserStore);
  private readonly redirectWithPostService: RedirectWithPostService = inject(RedirectWithPostService);

  protected readonly isImpersonated: Signal<boolean> = computed(() => this.userStore.userInfo()?.isImpersonatingTenant ?? false);

  @HostListener('document:click', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected clickout(event: any): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.selectedMenu = null;
      this.menuHeader()?.nativeElement.setAttribute('current', '');
    }
  }

  protected openMenu(menu: MenuType): void {
    if (this.selectedMenu === menu) {
      this.clearMenuSelection();
      return;
    }
    this.selectedMenu = menu;
  }

  protected clickLogout(): void {
    void this.redirectWithPostService.redirectWithPost<LogoutRazorPostData>('/Account/Logout', { returnUrl: '/' });
  }

  protected clearMenuSelection(): void {
    this.menuHeader()?.nativeElement.setAttribute('current', '');
    this.selectedMenu = null;
  }
}
